import { getImportantSegmentValues } from '@data/queries/experiment/getImportantSegmentValues'
import { QueryResultWithSegment } from '@data/queries/experiment/types'
import { UseQueryResult } from '@tanstack/react-query'
import { exposeExperimentToNewRelic } from '@tracking/exposeExperimentToNewRelic'
import { useStableReference } from '@util/useStableReference'
import { useMemo } from 'react'

const DEFAULT_SEGMENT: TExperimentSegment = 'A'

export function useExperimentSegmentValues({
    queryResult,
    experimentName,
}: {
    queryResult: UseQueryResult<TExperimentMap, ApiError>
    experimentName: TExperimentName
}): QueryResultWithSegment {
    const segment: TExperimentSegment = useMemo(() => {
        if (!queryResult.data || !queryResult.isSuccess) {
            return DEFAULT_SEGMENT
        }

        const segmentValue = queryResult.data[experimentName]

        if (!segmentValue) {
            return DEFAULT_SEGMENT
        }

        exposeExperimentToNewRelic(experimentName, segmentValue)

        return segmentValue
    }, [experimentName, queryResult.data, queryResult.isSuccess])
    const segmentValues = useMemo(() => getImportantSegmentValues(segment), [segment])
    const result = useStableReference({ ...queryResult, segment, ...segmentValues })

    return result
}
